import React, { useState } from "react";
import "../../iqac.css";
import TopNav from "../../../../../Components/TopNav";
import Navbar from "../../../../../Components/Navbar";
import DropdownNav from "../../../../../Components/DropdownNav";
import Footer from "../../../../../Components/Footer";
import Example from "../../../../../Components/Example";
import ScrollToTop from "react-scroll-to-top";

const DepartmentofAide = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <Example />
      <ScrollToTop smooth top="1000" />
      <div className="navbar-area">
        <div className="doa-image">
          <div className="image-cover"></div>
        </div>
      </div>

      {/* This iqac details part */}

      <div className="iqac-details">
        <div className="iqac-header">
          <h1>Internal Quality Assurance Cell - (IQAC)</h1>
          <h1 className="iqac-obj-tit">Roles of Department Aide</h1>
        </div>
      </div>

      <div className="iqac-obj-det">
        <button
          onClick={() => setIsOpen((e) => !e)}
          style={{
            marginTop: "20px",
            backgroundColor: "#0c4da2",
            padding: ".7rem",
            color: "white",
            width: "30%",
            alignItems: "center",
            marginLeft: "5%",
            borderRadius: ".3rem",
            cursor: "pointer",
            textAlign: "left",
          }}
        >
          Objective of the IQAC
        </button>
        {isOpen && (
          <div className="obj-items">
            <p>
              ✬ Members of the AIDES are decentralized functionaries of IQAC at
              the department. They act as contact persons of the department on
              voluntary basis.
            </p>
            <p>
              ✬ They function as the collaborators and facilitator for the
              smooth functioning of IQAC.
            </p>
            <p>
              ✬ The role of the members of AIDES is crucial, cumbersome and
              challenging.
            </p>
            <p>
              ✬ They must be intertwined with the faculty members of the
              department they belong and the activities of the IQAC of the
              college. In other words they should act as the mediator between
              the IQAC and the faculty colleagues.
            </p>
            <p>
              ✬ They must be aware every nook and corner of the departmental
              functions.
            </p>
            <p>
              ✬ They must maintain a record of the various activities of the
              department for the preparation of the evaluative report of the
              department. They should keep track of all the activities starting
              from admission to the welfare of the students, individual
              faculty's progress to the growth of the department, etc.
            </p>
            <p>
              ✬ They are the brain behind to maintain the quality of the
              department and enhancing / sustaining the level of the department
              in all aspects.
            </p>
            <p>✬ They are expected to assist the Head in all aspects.</p>
            <p>
              ✬ They should have good rapport with all the faculty colleagues
              and make their presence visible and bright in the department.
            </p>
            <p>
              ✬ Members are required to assist the parents during the
              Parent-Teachers meet to fillup the feedback form by the parents
              and the same to be handed over to the IQAC co-ordinator.
            </p>
          </div>
        )}
      </div>

      <h3 style={{ textAlign: "center", marginBottom: "40px" }}>
        IQAC Aide List 2023 - 2024
      </h3>

      <table>
        <tr>
          <th>S. No</th>
          <th> Department</th>
          <th> Name of the Faculty</th>
        </tr>
        <tr>
          <td>1</td>
          <td>Arabic</td>
          <td>
            {" "}
            Dr. Syed Fazlullah Bakhtiary <br></br>
            Dr. R. Md. Yousuf
          </td>
        </tr>
        <tr>
          <td>2</td>
          <td> Bank Management</td>
          <td> Dr. S. Mohamed Moosa</td>
        </tr>
        <tr>
          <td>3</td>
          <td> Biotechnology</td>
          <td> Dr. A. Mohamed Halith</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Botany</td>
          <td> Dr. Amzad Basha Kolar</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Business Administration</td>
          <td> Dr. M. Sadik Ali</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Chemistry</td>
          <td> Dr. A. Mohammed Ibrahim</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Commerce</td>
          <td>
            Mr. R.B. Syed Ahammed Jalalutheen<br></br>
            Dr. K. Shriram<br></br>
            Mr. T. Thavaprabhu
          </td>
        </tr>
        <tr>
          <td>8</td>
          <td>Computer Applications</td>
          <td>Dr. K. Sankar</td>
        </tr>
        <tr>
          <td>9</td>
          <td>Computer Science</td>
          <td>
            Dr. K. Tajudin <br></br>
            Dr. S. Noordeen
          </td>
        </tr>
        <tr>
          <td>10</td>
          <td> Corporate Secretaryship</td>
          <td>
            Dr. G. Mohamed Abbas Khan <br></br>
            Mr. B. Syed Asif
          </td>
        </tr>
        <tr>
          <td>11</td>
          <td> Economics</td>
          <td>
            Mr. R. Mohammed Ali <br></br>
            Mr. M. Shahul Hameed
          </td>
        </tr>
        <tr>
          <td>12</td>
          <td> English</td>
          <td>
            {" "}
            Mr. A. Mohammed Farhatullah <br></br>
            Mr. A. Joshua Pravin Kumar <br></br>
            Mr. M. Mohamed Shafeeq Basha
          </td>
        </tr>
        <tr>
          <td>13</td>
          <td> French</td>
          <td> Dr. M. K. Muhammed Junais</td>
        </tr>
        <tr>
          <td>14</td>
          <td> Hindi</td>
          <td>Dr. Sayyad Arifulla</td>
        </tr>
        <tr>
          <td>15</td>
          <td>Historical Studiesp</td>
          <td>Mr. E. S. Muhammed Aslam </td>
        </tr>
        <tr>
          <td>16</td>
          <td> Information Systems Management</td>
          <td>Dr. S. Niyas Ahamed</td>
        </tr>
        <tr>
          <td>17</td>
          <td>Mathematics</td>
          <td>
            Mr. A. K. Abdul Nazeer <br></br>
            Mr. M. Mohamed Riyasdeen
          </td>
        </tr>
        <tr>
          <td>18</td>
          <td>Physics</td>
          <td>
            Dr. Mohammed Musthafa Kummali <br></br>
            Dr. L. Allwin Joseph
          </td>
        </tr>
        <tr>
          <td>19</td>
          <td>Sociology</td>
          <td>Mr. K.V. Mohammed Bilal</td>
        </tr>
        <tr>
          <td>20</td>
          <td>Tamil</td>
          <td>Dr. B. Hussain Khan</td>
        </tr>
        <tr>
          <td>21</td>
          <td> Urdu</td>
          <td>Mr. Syed Shabbeer Hussain</td>
        </tr>
        <tr>
          <td>22</td>
          <td>Zoology</td>
          <td>Dr. S. Syed Raffic Ali</td>
        </tr>
        <tr>
          <td>23</td>
          <td>Accounting & Finance</td>
          <td>Dr. M. Muhammed Rafee</td>
        </tr>
        <tr>
          <td>24</td>
          <td>Information Technology</td>
          <td>Dr. A. Mohamed Mustaq Ahmed</td>
        </tr>
        <tr>
          <td>25</td>
          <td> Criminology & Police Administration</td>
          <td>Mr. T. Mohammed Rameez</td>
        </tr>
        <tr>
          <td>26</td>
          <td> Defence and Strategic Studies</td>
          <td> Mr. P. Kousik Raj</td>
        </tr>
        <tr>
          <td>27</td>
          <td> Electronic Media</td>
          <td>Mr. D. Kaviyarasan</td>
        </tr>
        <tr>
          <td>28</td>
          <td> Professional Accounting</td>
          <td> Mr. M. Mohammed Arshad Ahmed</td>
        </tr>
        <tr>
          <td>29</td>
          <td> Computer Science with Artificial Intelligence</td>
          <td> Mr. S. Zahir Hussain</td>
        </tr>
        <tr>
          <td>30</td>
          <td> Computer Science with Data Science</td>
          <td> Mr. A. Ameer Rashed Khan</td>
        </tr>
        <tr>
          <td>31</td>
          <td>Physical Education</td>
          <td> Mr. M. Nasar Khan</td>
        </tr>
        <tr>
          <td>32</td>
          <td>Library</td>
          <td> Mr. M.H. Rifayul Jeburi</td>
        </tr>
        <tr>
          <td>33</td>
          <td>Office of Controller of Examinations</td>
          <td> Mr. J. Syed Ibrahim</td>
        </tr>
        <tr>
          <td>34</td>
          <td>Administrative Office</td>
          <td>
            Mr. M. Thameem Basha <br></br>
            Mr. J. Abdul Rahuman
          </td>
        </tr>
      </table>

      <Footer />
    </div>
  );
};

export default DepartmentofAide;
